import * as Schema from 'owa-graph-schema';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import handleServerResponseSuccessAndError from 'owa-service-utils/lib/handleServerResponseSuccessAndError';
import message from 'owa-service/lib/factory/message';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import setItemField from 'owa-service/lib/factory/setItemField';
import itemId from 'owa-service/lib/factory/itemId';
import ItemChange from 'owa-service/lib/contract/ItemChange';
import itemChange from 'owa-service/lib/factory/itemChange';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export const markItemAsReadWeb = async (
    parent: any,
    args: Schema.MutationMarkItemAsReadArgs,
    context: Schema.ResolverContext,
    info: any
): Promise<Schema.MarkItemAsReadResult> => {
    const update = setItemField({
        Path: propertyUri({ FieldURI: 'IsRead' }),
        Item: message({ ['IsRead']: args.options.isRead }),
    });

    const itemChanges: ItemChange[] = [];
    args.options.ids.forEach(id =>
        itemChanges.push(
            itemChange({
                Updates: [update],
                ItemId: itemId({ Id: id }),
            })
        )
    );

    const requestBody = updateItemRequest({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
        SuppressReadReceipts: args.options.suppressReadReceipts,
    });

    const response = await updateItemOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        getMailboxRequestOptions(args.options.mailboxInfo, context.requestOptions)
    );

    return handleServerResponseSuccessAndError(response?.Body?.ResponseMessages?.Items?.[0]).then(
        () => {
            return {
                __typename: 'MarkItemAsReadResult',
                success: true,
            };
        }
    );
};
